<template>
  <image-button
    :image="buttonImage"
    :title="title"
    :text="text" 
    :block="block" 
    :icon="icon" 
    :disabled="disabled"
    :btnClass="btnClass + (this.active ? ' active' : '')"
    :x-small="xSmall"
    :small="small"
    :medium="medium"
    :large="large"
    :x-large="xLarge"
    :fab="fab"
    @click="$emit('click', $event)"/>
</template>

<script>
import imageButton from "./ImageButton";
export default {
  name: "activeImageButton",
  components: {imageButton},
  props: {
    image: String,
    activeImage: String,
    active: Boolean,
    title: String,
    btnClass:  String,
    xSmall: Boolean,
    small: Boolean,
    medium: Boolean,
    large: Boolean,
    xLarge: Boolean,
    fab: Boolean,
    text: Boolean,
    block: Boolean,
    icon: Boolean,
    disabled: Boolean
  },
  computed: {
    buttonImage(){
      return this.active ? this.activeImage : this.image;
    }
  }
}
</script>